import { DTOAdvertisement, DTOAdvertisementImage } from "./WickedApiClient";

export class DTOAdvertisementEx extends DTOAdvertisement {
  get mainImage(): DTOAdvertisementImage | undefined {
    return this.images && this.images.length > 0 ? this.images[0] : undefined;
  }

  static fromJS(data: any): DTOAdvertisementEx {
    data = typeof data === "object" ? data : {};
    let result = new DTOAdvertisementEx();
    result.init(data);
    return result;
  }
}
